import { db } from "./config";
import {
    doc,
    setDoc,
    updateDoc,
    collection,
    addDoc,
    getDocs,
    deleteDoc,
    deleteField,
} from "firebase/firestore";

// List-level Functions

// Create a new list
export const createList = async (listData, userId) => {
    const listId = Date.now().toString();
    const newList = {
        id: listId,
        name: listData.name || "",
        ownerId: userId,
        invites: listData.invites || [],
        items: [],
        members: [userId],
        memberInfo: [
            {
                uid: userId,
                displayName: listData.displayName || "",
            },
        ],
        isSecretSanta: listData.isSecretSanta || false,
        participants: listData.participants || [], // Ex. [{ name: "", userId: null, assignedTo: null }]
    };

    await setDoc(doc(db, "lists", listId), newList);
    return newList;
};



// Fetch all lists (including their Firestore IDs)
export const getAllLists = async () => {
    const snapshot = await getDocs(collection(db, "lists"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Invite a user to a shared list
export const inviteUserToList = async (listId, invitedUid, role = "member") => {
    const listRef = doc(db, "lists", listId);
    await updateDoc(listRef, {
        [`members.${invitedUid}`]: { role },
    });
};

// Leave a shared list
export const leaveList = async (listId, uidToRemove) => {
    const listRef = doc(db, "lists", listId);
    await updateDoc(listRef, {
        [`members.${uidToRemove}`]: deleteField(),
    });
};

// Delete a list
export const deleteList = async (listId) => {
    const listRef = doc(db, "lists", listId);
    await deleteDoc(listRef);
};

// Item-level Functions (Subcollection)

// Get all items for a list
export const getListItems = async (listId) => {
    const itemsRef = collection(db, "lists", listId, "items");
    const snapshot = await getDocs(itemsRef);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Add a new item to a list
export const addListItem = async (listId, item) => {
    const itemsRef = collection(db, "lists", listId, "items");
    const docRef = await addDoc(itemsRef, item);
    return { id: docRef.id, ...item };
};

// Update an existing item
export const updateListItem = async (listId, itemId, data) => {
    const itemRef = doc(db, "lists", listId, "items", itemId);
    await updateDoc(itemRef, data);
};

// Delete an item
export const deleteListItem = async (listId, itemId) => {
    const itemRef = doc(db, "lists", listId, "items", itemId);
    await deleteDoc(itemRef);
};
